import { useCommandState } from 'cmdk';
import algoliasearch from 'algoliasearch/lite';
import type { Hit } from 'instantsearch.js';
import { InstantSearch, Index, useHits, Configure } from 'react-instantsearch';
import { Dispatch, SetStateAction, useEffect } from 'react';

const searchClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID ?? 'RA7W9NZP4T',
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY ??
    '52385d30a5ca4460564defe5b2d0ffb1'
);

/**
 * Access the Algolia state and expose the results via a provided state setter
 */
function ResultsReporter({
  setResults
}: {
  setResults: Dispatch<SetStateAction<Hit[]>>;
}) {
  const { hits, results } = useHits();
  useEffect(() => {
    // Only set results if a query has been provided, otherwise we'll get the entire index
    if (results?.query) {
      setResults(hits);
    } else {
      setResults((cur: Hit[]) => {
        // Prevent a needless update if the results are already empty
        if (cur.length === 0) return cur;
        return [];
      });
    }
  }, [hits, results?.query]);
  return null;
}

/**
 * Configures Algolia via the <InstantSearch /> component and handles querying based on cmdk's state
 */
export function SearchFetcher({
  setResults
}: {
  setResults: Dispatch<SetStateAction<Hit[]>>;
}) {
  const query = useCommandState(state => state.search);

  return (
    <InstantSearch searchClient={searchClient}>
      <Index indexName={process.env.NEXT_PUBLIC_ALGOLIA_INDEX_NAME!}>
        <Configure query={query} />
        <ResultsReporter setResults={setResults} />
      </Index>
    </InstantSearch>
  );
}
